import React from "react";
import { COMPONENT_TYPES } from "@/helpers/constants";
import BannerWithImage from "@/components/PagePiller/components/BannerWithImage";
import ClusterListComponent from "@/components/PagePiller/components/ClusterList";
import VideoWidgetComponent from "@/components/PagePiller/components/VideoWidget";
import ContentImageDescComponent from "@/components/PagePiller/components/ContentImageDesc";
import ClusterActionCardsComponent from "@/components/PagePiller/components/ClusterActionCards";
import ContentDescriptionComponent from "@/components/PagePiller/components/ContentDescription";
import TopTipsComponent from "@/components/PagePiller/components/TopTips";
import FAQComponent from "@/components/FAQ";
import ArticleComponent from "@/components/ArticleComponent";
import ArticlesByTagComponent from "@/components/PagePiller/components/ArticlesByTag";
import PageIndex from "@/components/PagePiller/components/PageIndex";
import ShoppingComponent from "@/components/ShoppingComponent";
import DoctorsWidget from "@/components/DoctorsWidget";
import DiagnosticsWidget from "@/components/DiagnosticsWidget";

interface ComponentMappingProps {
  data: any;
  extras?: { [key: string]: any };
  index?: number;
  isPharma?: boolean;
}

const componentMapping = (props: ComponentMappingProps): React.ReactElement => {
  const { data, extras = {}, index, isPharma = false } = props;
  const {
    userAgent,
    registerRef,
    elementRefs,
    indexContent,
    productInfo,
    currentSpeciality,
    doctorsArray,
    diagnostics,
  } = extras;
  const type = data.ComponentType;

  switch (type) {
    case COMPONENT_TYPES.Index:
      return <PageIndex data={indexContent} elementRefs={elementRefs} userAgent={userAgent} />;
    case COMPONENT_TYPES.BannerWithCard:
      return <BannerWithImage data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ClusterList:
      return (
        <ClusterListComponent data={data} userAgent={userAgent} registerRef={registerRef} assetPosition={index + 1} />
      );
    case COMPONENT_TYPES.VideoWidget1:
      return <VideoWidgetComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ContentImageDesc:
      return <ContentImageDescComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ClusterActionCards:
      return <ClusterActionCardsComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ArticlesByTag:
      return (
        <ArticlesByTagComponent
          data={data}
          userAgent={userAgent}
          registerRef={registerRef}
          assetPosition={index + 1}
          pillarSlug={extras?.pillarSlug}
          isPharma={isPharma}
        />
      );

    case COMPONENT_TYPES.ArticlesWithTagSlider:
      const articleData = {
        articles: data?.ArticlesList,
        ...data,
      };

      return (
        <ArticleComponent
          data={articleData}
          userAgent={userAgent}
          categorySlug={extras?.categorySlug}
          pillarSlug={extras?.pillarSlug}
          registerRef={registerRef}
          desktopItems={2}
          assetPosition={index + 1}
        />
      );
    case COMPONENT_TYPES.ContentDescription:
      return (
        <section
          data-ref_id={data?.refId}
          ref={(el) => {
            if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
          }}
          className={"container scrollMargin spacingBetweenSections"}
        >
          <ContentDescriptionComponent data={data?.Description} userAgent={userAgent} />
        </section>
      );
    case COMPONENT_TYPES.TopTips:
      return <TopTipsComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.FaqListWithTitle:
      return <FAQComponent data={data} />;
    case COMPONENT_TYPES.ShopByCatSlider:
      return <ShoppingComponent data={data} productInfo={productInfo} userAgent={userAgent} />;
    case COMPONENT_TYPES.DoctorConsult:
      return (
        <DoctorsWidget
          data={data}
          userAgent={userAgent}
          currentSpeciality={currentSpeciality}
          doctors={doctorsArray}
          utm_medium="pillar-page"
        />
      );
    case COMPONENT_TYPES.LabTest:
      return (
        <div className="spacingBetweenSections">
          <DiagnosticsWidget data={data} userAgent={userAgent} diagnostics={diagnostics} utm_medium="pillar-page" />
        </div>
      );
    default:
      // return undefined;

      return <></>;
  }
};

export default componentMapping;
